<template>
	<v-col class="ma-0 pa-0" cols="12" align="center">
		<v-row class="ma-0 pa-0" align="center">
			<v-col class="ma-0 pa-2" cols="4" align="center"
				v-for="item in loaderCount" :key="item">
				<v-skeleton-loader :boilerplate="false" elevation="0" dark 
					type="image" :width="width" :height="height"
				></v-skeleton-loader>
			</v-col>
		</v-row>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
export default {
	props: {
		loaderCount: Number,
		width: String,
		height: String
	},
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		
	}),
}
</script>

<style lang="scss" scoped>

</style>